export const GET_VACCINE_COUNT='GET_VACCINE_COUNT';